module.exports = __webpack_public_path__ + "img/BS_productshop_header.31fc7158.png";